import {
  GlobalMessages,
  TranslationGlobalMessages
} from "../interfaces/globalMessages";

export const messages: TranslationGlobalMessages = {
  [GlobalMessages.activeText]: "Ativo",
  [GlobalMessages.inactiveText]: "Inativo",
  [GlobalMessages.yesText]: "Sim",
  [GlobalMessages.noText]: "Não",
  [GlobalMessages.filtersText]: "Filtros",
  [GlobalMessages.underConstructionText]: "Em construção",
  [GlobalMessages.columnActions]: "Ações",
  [GlobalMessages.buttonAdd]: "Adicionar novo",
  [GlobalMessages.buttonEdit]: "Editar",
  [GlobalMessages.buttonDelete]: "Excluir",
  [GlobalMessages.buttonRefresh]: "Atualizar",
  [GlobalMessages.buttonClose]: "Fechar",
  [GlobalMessages.buttonPrint]: "Imprimir",
  [GlobalMessages.buttonExport]: "Exportar",
  [GlobalMessages.buttonCancel]: "Cancelar",
  [GlobalMessages.buttonAccept]: "Aceitar",
  [GlobalMessages.buttonReject]: "Recusar",
  [GlobalMessages.buttonSaveChanges]: "Salvar alterações",
  [GlobalMessages.buttonView]: "Visualizar",
  [GlobalMessages.buttonHelp]: "Ajuda",
  [GlobalMessages.tooltipFixed]:
    "Registros fixos (pré definidos) não podem ser manipulados",
  [GlobalMessages.noItemsText]: "Não há itens para exibir",
  [GlobalMessages.clientSelectInstruction]: "Digite pelo menos 3 caracteres",
  [GlobalMessages.entityClassificationSupplyType]:
    "Tipo de classificação de insumo",
  [GlobalMessages.entityConcreteBatchingPlant]: "Central dosadora de concreto",
  [GlobalMessages.entityMeasureUnitType]: "Tipo de unidade de medida",
  [GlobalMessages.entitySupplier]: "Fornecedor",
  [GlobalMessages.entityConcreteCharacteristicsType]: "Tipo de características",
  [GlobalMessages.entityGravel]: "Brita",
  [GlobalMessages.entitySlump]: "Slump",
  [GlobalMessages.entityConcreteRecipeFamilyApplicationType]:
    "Tipo de aplicação da família de traço",
  [GlobalMessages.invalidFormInputs]:
    "Preencha todas as informações obrigatórias da aba atual",
  [GlobalMessages.invalidMinEffectiveDate]:
    "A data deve ser maior ou igual a data de vigência ativa",
  [GlobalMessages.measureUnitCharacteristicMPa]: "MPa",
  [GlobalMessages.emptySelectField]: "Nenhum",
  [GlobalMessages.selectClient]: "Selecione o cliente",
  [GlobalMessages.dayDeliveryText]: "Últimas entregas do dia",
  [GlobalMessages.lastConcretingRequestsText]:
    "Últimas solicitações de programação",
  [GlobalMessages.lastContractsText]: "Últimos contratos",
  [GlobalMessages.searchText]: "Pesquisar",
  [GlobalMessages.showMore]: "Mostrar mais",
  [GlobalMessages.reversibleAction]:
    "Essa ação pode ser revertida posteriormente",
  [GlobalMessages.successText]: "Sucesso",
  [GlobalMessages.warningText]: "Aviso",
  [GlobalMessages.errorText]: "Erro",
  [GlobalMessages.lgpdTitle]: "Termo de compartilhamento de dados"
};
